const propertyDetailsInitialState = {
    searchedAddress: 'london',
    searchInProgress: false,
    propertyList: [],
    selectedProperty: {},
};

export default propertyDetailsInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/PropertyDetails/propertyDetailsInitialState.js